import React from "react";
import {connect} from "react-redux";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import PostTag from "./PostTag";


class PostTags extends React.Component{
    constructor(props) {
        super(props);
    }

    formateTags(tagGeo, tags){
        const geo_tags = tagGeo ? [{tag: tagGeo, isGeo: true}] : [];
        const theme_tags = tags.map((item) => ({tag: item, isGeo: false}));

        return geo_tags.concat(theme_tags)
    }

    render() {
        const styles = StyleSheet.create({
            postTagContainer:{
                marginTop:18,
                flexWrap:"wrap",
                flexDirection:"row",
                maxWidth:"100%"
            },
            dotContainer:{
                justifyContent:"center",
                alignItems:"center",
                marginTop:2,
                marginRight:5
            },
            dot:{
                backgroundColor:this.props.theme.colors.tertiary.black8.value,
                width:3 ,
                height:3,
                borderRadius:20
            }
        });

        return (
            <View style={styles.postTagContainer}>
                { this.formateTags(this.props.tagGeo, this.props.tags).map((item, index) => {

                    return <View key={index}  style={{flexDirection: "row"}}>
                      { /* dots separating each tag */ }
                      { index === 0 ? <View /> : <View style={styles.dotContainer}><View style={styles.dot} /></View> }

                      <PostTag key={index} _navigateToEntityScreen={this.props._navigateToEntityScreen} tag={item.tag} isGeo={item.isGeo} />
                    </View>
                })}
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(PostTags);
